import { UserCog } from 'lucide-react';

const AdminSidebarHeader = () => (
  <div className="p-2">
    <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center text-primary transition-colors">
      <UserCog className="size-7" />
    </div>
  </div>
);

export default AdminSidebarHeader;
